module.exports = __webpack_public_path__ + "img/Lifegiver1.e69752ee.png";